"use client";

import { usePathname } from "next/navigation";
import clsx from "clsx";
import { useScroll, useTransform, motion } from "framer-motion";
import { useRef } from "react";
import Footer from "@components/utils/footer/Footer";
import FooterWhiteBlock from "@components/utils/footer/FooterWhiteBlock";
import { useMediaQuery } from "../../_hooks/useMediaQuery";

type LayoutContentProps = {
	children: React.ReactNode;
};

export default function LayoutContent({ children }: LayoutContentProps) {
	const pathname = usePathname();
	const is404Page = pathname.endsWith("/404");
	const mainRef = useRef<HTMLElement>(null);
	const isDesktop = useMediaQuery("(min-width: 990px)");

	const { scrollYProgress } = useScroll();
	// Calculate when to start showing margins (at 80% of scroll progress = 20% from end)
	const marginLeft = useTransform(scrollYProgress, [0.8, 1], [0, isDesktop ? 20 : 14]);
	const marginRight = useTransform(scrollYProgress, [0.8, 1], [0, isDesktop ? 20 : 14]);

	return (
		<>
			<motion.main
				ref={mainRef}
				className={clsx("relative z-1 bg-white")}
				style={{
					marginLeft,
					marginRight,
				}}
			>
				{children}
				{!is404Page && <FooterWhiteBlock />}
			</motion.main>
			{!is404Page && <Footer />}
		</>
	);
}
